import React from 'react';
import { Link } from 'react-router-dom';

const SECTIONS = [
  { to: '/companies', title: 'Контрагенты', description: 'Управление юридическими лицами и контрагентами' },
  { to: '/departments', title: 'Структурные подразделения', description: 'Структурные подразделения компаний' },
  { to: '/employees', title: 'Сотрудники', description: 'Управление персоналом организаций' },
  { to: '/jobs', title: 'Должности', description: 'Справочник должностей и ролей' },
  { to: '/probation-instructions', title: 'Стажировка', description: 'Стажировка на рабочем месте' },
  { to: '/instructions', title: 'Вводный инструктаж', description: 'Вводный инструктаж по охране труда' },
  { to: '/fire-instructions', title: 'Противопожарный инструктаж', description: 'Инструктаж по пожарной безопасности' },
  {
    to: '/labor-safety-instructions',
    title: 'Инструктаж по охране труда',
    description: 'Первичный и повторный инструктаж на рабочем месте',
  },
];

export const WorkPage: React.FC = () => {
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Система управления безопасностью</h1>
        <p>Добро пожаловать в систему управления контрагентами, отделами, сотрудниками и должностями.</p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {SECTIONS.map(section => (
          <div key={section.to} className="card">
            <h3>{section.title}</h3>
            <p>{section.description}</p>
            <Link to={section.to} className="btn btn-primary">Перейти</Link>
          </div>
        ))}
      </div>
    </div>
  );
};
